import './style';
import 'regenerator-runtime/runtime';
import 'core-js/stable';

(($) => {

	$(document).ready(() => {

		if (!sessionStorage.getItem('checkout-popup-do-not-show')) {
			$('#checkout-popup').css('display', 'flex');
		}

		$('#close-checkout-popup').on('click', function (e) {
			e.preventDefault();

			sessionStorage.setItem('checkout-popup-do-not-show', true);

			$('#checkout-popup').hide();
		});

		$('.ajax_add_to_cart_checkout_popup').on('click', function (e) {
			e.preventDefault();
			$(this).prop('disabled', true);

            var product = $(this).data('product');
            var variation = $(this).data('variation');
    
            var data_add_to_cart = {
                action: 'add_product_to_cart_checkout_popup',
                product_id: product,
                quantity: 1,
                variation_id: variation,
            };
    
            $.ajax({
                url: ajaxurl,
                type: 'post',
                data: data_add_to_cart,
                error: function(response) {
                    console.error(response);
                    $('#checkout-popup').hide();
                },
                success: function(response) {
					sessionStorage.setItem('checkout-popup-do-not-show', true);

					if (response) {
						if (response.fragments) {
							if ($('body').hasClass('svea-checkout-page')) {
								$(document.body).trigger('update_checkout');
							}

							if ($('body').hasClass('woocommerce-cart')) {
								$(document).trigger('wc_update_cart', true);
							}
						}

						if (response.product_url) {
							window.location.replace(response.product_url);
						}
					}

                    $('#checkout-popup').hide();
				},
			});
		});

        const settingsFlickitySlider = {
            imagesLoaded: true,
            groupCells: '100%',
            dragThreshold: 5,
            cellAlign: 'left',
            wrapAround: true,
            prevNextButtons: true,
            percentPosition: true,
            pageDots: false,
            rightToLeft: false,
            autoPlay: false,
            lazyLoad : true
        };

        const carousel = jQuery(
			'.wc-prl-recommendations .products',
		);

		if (carousel.length) {

            carousel.on( 'ready.flickity', function() {
                $('.wc-prl-recommendations .products .product').css('display','block')
            });

			carousel.lazyFlickity(settingsFlickitySlider);
		}

        let carouselSingleUpsells = jQuery(
			'.single-product .upsells .row',
		);

        if (carouselSingleUpsells.length) {

            let initialized = false

            $(window).on('resize', function(){

                let win = $(this);

                    if (win.width() >= 850) {

                        if(initialized) {
                            carouselSingleUpsells.lazyFlickity('destroy')
                            initialized = false
                        }
                    }
                    else {

                        carouselSingleUpsells.lazyFlickity(settingsFlickitySlider).on( 'ready.flickity', function() {
                            initialized = true
                        });
                    }


            }).trigger('resize')

        }

        const get_url = function( endpoint ) {
            return wc_cart_params.wc_ajax_url.toString().replace(
                '%%endpoint%%',
                endpoint
            );
        };

        $('.cart-collaterals').on('submit', 'form.checkout_coupon', function(e) {

            e.preventDefault();

            const coupon_code =  $('#coupon_code').val()

            const data = {
                coupon_code: coupon_code, 
                security: wc_cart_params.apply_coupon_nonce,
            };

            $.ajax({
                url: get_url( 'apply_coupon' ),
                type: 'post',
                data: data,
                error: function (response) {
                    console.log(response);
                },
                success: function (response) {
                
                    $( document.body ).on( 'updated_wc_div', function() {

                        $(document).find('.woocommerce-notices-wrapper').empty()

                        $('.woocommerce-notices-wrapper').append( response )

                        setTimeout(() => window.scrollTo(0, 0) )
    
                    } );
                    
                    $('.woocommerce-cart-form button').attr('disabled', false)

                    $('.woocommerce-cart-form button').click()

                    $('#coupon_code').val('')
    
                },
            });

        });

	});
})(jQuery);
